const doc = [({"da":({"js":({"merfoto":({"layout":({"top_bar":({"index":({"sign_in":"Log ind"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;